module.exports = __webpack_public_path__ + "static/img/meticulousmaid-cartoon1.ae89dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meticulousmaid-cartoon1.png
// module id = synJ
// module chunks = 11